export default __webpack_public_path__ + "static/trousse.inspirations-32c7be7b98abc8950d9507842601f36e.jpg";